export interface BaseItem {
  id: number;
  title?: string;
  Title?: string;
  documentId?: string;
}

export interface Reference {
  id: number;
  title?: string;
  documentId?: string;
}

export interface Group extends BaseItem {
  factories?: Factory[];
  gops?: GOP[];
}

export interface Factory extends BaseItem {
  departments?: Department[];
  group?: Reference;
}

export interface GOP extends BaseItem {
  directions?: Direction[];
  group?: Reference;
}

export interface Direction extends BaseItem {
  departments?: Department[];
  blocks?: Block[];
  gop?: Reference;
}

export interface Department extends BaseItem {
  direction?: Reference;
  factory?: Reference;
}

export interface Block extends BaseItem {
  direction?: Reference;
}

export interface FilterItem {
  ID: number;
  Title: string;
}

export interface CurrentFilters {
  groupGop?: {
    selectedIds?: number[];
  };
  formGopAction?: {
    selectedIds?: number[];
  };
  direction?: {
    selectedIds?: number[];
  };
  factoryGop?: {
    selectedIds?: number[];
  };
}

//! Получения заводов для выбранных групп
export const getFactoriesForSelectedGroups = (currentFilters: CurrentFilters, groupGop: Group[],factoriesGop: Factory[] = []) => {
  if (!currentFilters?.groupGop?.selectedIds?.length || !groupGop?.length) {
    return factoriesGop;
  }

  const selectedGroupIds = currentFilters.groupGop.selectedIds;
  const allFactoriesFromSelectedGroups: Factory[] = [];

  selectedGroupIds.forEach((groupId) => {
    const selectedGroup = groupGop.find((group) => group.id === groupId);
    if (selectedGroup?.factories) {
      const factoriesWithGroup = selectedGroup.factories.map((factory) => ({
        ...factory,
        group: {
          id: selectedGroup.id,
          title: selectedGroup.title || selectedGroup.Title,
          documentId: selectedGroup.documentId,
        },
      }));
      allFactoriesFromSelectedGroups.push(...factoriesWithGroup);
    }
  });

  const uniqueFactories = allFactoriesFromSelectedGroups.filter((factory, index, self) => index === self.findIndex((f) => f.id === factory.id));
  return uniqueFactories;
};

//! Получения финально отфильтрованных заводов для ui
export const getFinalFilteredFactories = (
  currentFilters: CurrentFilters, 
  groupGop: Group[], 
  factoriesGop: Factory[] = []
): Factory[] => {
  const factoriesByGroups = getFactoriesForSelectedGroups(currentFilters, groupGop, factoriesGop);

  if (!currentFilters?.factoryGop?.selectedIds?.length) {
    return factoriesByGroups;
  }

  const selectedFactoryIds = currentFilters.factoryGop.selectedIds;
  return factoriesByGroups.filter((factory) => selectedFactoryIds.includes(factory.id));
};

//! Получения ГОП для выбранных групп
export const getGOPsForSelectedGroups = (currentFilters: CurrentFilters, groupGop: Group[], formGops: GOP[] = []) => {
  if (!currentFilters?.groupGop?.selectedIds?.length || !groupGop?.length) {
    return formGops;
  }

  const selectedGroupIds = currentFilters.groupGop.selectedIds;
  const allGOPsFromSelectedGroups: GOP[] = [];

  selectedGroupIds.forEach((groupId) => {
    const selectedGroup = groupGop.find((group) => group.id === groupId);
    if (selectedGroup?.gops) {
      const gopsWithGroup = selectedGroup.gops.map((gop) => ({
        ...gop,
        group: {
          id: selectedGroup.id,
          title: selectedGroup.title || selectedGroup.Title,
          documentId: selectedGroup.documentId,
        },
      }));
      allGOPsFromSelectedGroups.push(...gopsWithGroup);
    }
  });

  const uniqueGOPs = allGOPsFromSelectedGroups.filter((gop, index, self) => index === self.findIndex((f) => f.id === gop.id));
  return uniqueGOPs;
};

//! Получения Направлений для выбранных ГОП
export const getDirectionsForSelectedGOPs = (currentFilters: CurrentFilters, formGops: GOP[]) => {
  if (!currentFilters?.formGopAction?.selectedIds?.length || !formGops?.length) {
    return [];
  }

  const selectedGOPIds = currentFilters.formGopAction.selectedIds;
  const allDirectionsFromSelectedGOPs: Direction[] = [];

  selectedGOPIds.forEach((gopId) => {
    const selectedGOP = formGops.find((gop) => gop.id === gopId);
    if (selectedGOP?.directions) {
      const directionsWithGOP = selectedGOP.directions.map((direction) => ({
        ...direction,
        gop: {
          id: selectedGOP.id,
          title: selectedGOP.title || selectedGOP.Title,
          documentId: selectedGOP.documentId,
        },
      }));
      allDirectionsFromSelectedGOPs.push(...directionsWithGOP);
    }
  });

  const uniqueDirections = allDirectionsFromSelectedGOPs.filter((direction, index, self) => index === self.findIndex((d) => d.id === direction.id));
  return uniqueDirections;
};

//! Получения Отделов от направлений и заводов
export const getDepartmentsForSelectedDirectionsAndFactories = (currentFilters: CurrentFilters, gopDirection: Direction[], factoriesGop: Factory[], departments: Department[]) => {
  const hasSelectedDirections = currentFilters?.direction?.selectedIds?.length;
  const hasSelectedFactories = currentFilters?.factoryGop?.selectedIds?.length;

  if (!hasSelectedDirections && !hasSelectedFactories) {
    return [];
  }

  const allDepartmentsFromSelected: Department[] = [];

  if (hasSelectedDirections && gopDirection?.length) {
    const selectedDirectionIds = currentFilters.direction?.selectedIds;
    selectedDirectionIds?.forEach((directionId) => {
      const selectedDirection = gopDirection.find((direction) => direction.id === directionId);
      if (selectedDirection?.departments) {
        const departmentsWithDirection = selectedDirection.departments.map((department) => ({
          ...department,
          direction: {
            id: selectedDirection.id,
            title: selectedDirection.title || selectedDirection.Title,
            documentId: selectedDirection.documentId,
          },
        }));
        allDepartmentsFromSelected.push(...departmentsWithDirection);
      }
    });
  }

  if (hasSelectedFactories && factoriesGop?.length) {
    const selectedFactoryIds = currentFilters.factoryGop?.selectedIds;

    selectedFactoryIds?.forEach((factoryId) => {
      const selectedFactory = factoriesGop.find((factory) => factory.id === factoryId);
      if (selectedFactory?.departments) {
        const departmentsWithFactory = selectedFactory.departments.map((department) => ({
          ...department,
          factory: {
            id: selectedFactory.id,
            title: selectedFactory.title || selectedFactory.Title,
            documentId: selectedFactory.documentId,
          },
        }));
        allDepartmentsFromSelected.push(...departmentsWithFactory);
      }
    });
  }

  const uniqueDepartments = allDepartmentsFromSelected.filter((department, index, self) => index === self.findIndex((d) => d.id === department.id));

  if (uniqueDepartments.length > 0) {
    return uniqueDepartments;
  }
  return departments;
};

//! Получение блоков требований для выбранных направлений
export const getBlocksForSelectedDirections = (currentFilters: CurrentFilters, gopDirection: Direction[]) => {
  if (!currentFilters?.direction?.selectedIds?.length || !gopDirection?.length) {
    return [];
  }

  const selectedDirectionIds = currentFilters.direction.selectedIds;
  const allBlocksFromSelectedDirections: Block[] = [];

  selectedDirectionIds.forEach((directionId) => {
    const selectedDirection = gopDirection.find((direction) => direction.id === directionId);
    if (selectedDirection?.blocks) {
      const blocksWithDirection = selectedDirection.blocks.map((block) => ({
        ...block,
        direction: {
          id: selectedDirection.id,
          title: selectedDirection.title || selectedDirection.Title,
          documentId: selectedDirection.documentId,
        },
      }));
      allBlocksFromSelectedDirections.push(...blocksWithDirection);
    }
  });

  const uniqueBlocks = allBlocksFromSelectedDirections.filter((block, index, self) => index === self.findIndex((b) => b.id === block.id));
  return uniqueBlocks;
};

//! трансформация данных для фильтров
export const transformDataForFilters = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
  }));
};
//! трансформация данных для фильтров
export const transformDataForFiltersInCode = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
    Code: item.Code || item.code || item.Title || item.title,
  }));
};

//! трансформация данных для фильтров
export const transformDataForFiltersInOptimacros = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
    Value: item.OptimacrosFactory,
    Group: item.group?.id
  }));
};

//! для гоп
export const transformDataForFiltersGOPs = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.description || item.description,
  }));
};